export const RegistrationReactQueryKey = {
  GetAccessTokenSilently: () => ['RegistrationReactQueryKey.GetAccessTokenSilently'],
  GetIdTokenClaims: () => ['RegistrationReactQueryKey.GetIdTokenClaims'],
  QueryGetUser: () => ['RegistrationReactQueryKey.QueryGetUser'],
  QueryGetReviewer: () => ['RegistrationReactQueryKey.QueryGetReviewer'],
  QueryGetCurrentReviewer: () => ['RegistrationReactQueryKey.QueryGetCurrentReviewer'],
  MutationAddUser: () => ['RegistrationReactQueryKey.MutationCreateUser']
};
